import { identifierModuleUrl } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DashboardService {

    getEventRoute = '/api/newevents/';

    constructor(private dataService: DataService) {
    };

    // getDashboard(districtId, blockId, villageId, date, isleastblock, refresh: boolean) {
    //     return this.dataService.getData('/api/dashboardchart/'
    //         + districtId + '/' + blockId
    //         + '/' + villageId + '/' + date + '/' + isleastblock, refresh);
    // }
    getDashboard(data, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/dashboardbarchart/' + data.districtId + '/' + data.blockId, refresh);
    }

    getLookupAreaType(langType: any, refresh: any) {
        return this.dataService.getData('/api/lookup/areaType', refresh)
    }

    getDashBoardData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/dashboardchart/' + data.districtId + '/' + data.blockId + '/' + data.sectorId, refresh);
    }

    getMapData(refresh: boolean, districtId, blockId, sectorId, awcId, malNutritionType) {
        return this.dataService.getData('/api/dashboard/mapdata/' + districtId + '/' + blockId + '/' + sectorId + '/' + awcId + '/' + malNutritionType, refresh);
    }

    getMapGeoJsonData(refresh: boolean, districtId, blockId, sectorId, awcId, malNutritionType) {
        return this.dataService.getData('/api/dashboard/mapgeojsondata/' + districtId + '/' + blockId + '/' + sectorId + '/' + awcId + '/' + malNutritionType, refresh);
    }

    getAllDashboardData(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/dashboarddata/' + data.districtId + '/' + data.blockId + '/' + data.sectorId, refresh);
    }

    getMapGridData(refresh: boolean, districtId, blockId, sectorId, severityType) {
        return this.dataService.getData('/api/dashboard/mapgriddata/' + districtId + '/' + blockId + '/' + sectorId + '/' + severityType, refresh);
    }

    getPlannedActualAdditionalDatas(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/mitargetactual/' + data.districtId + '/' + data.blockId, refresh);
    }

    getMiAgegroup(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/miagegroup/' + data.districtId + '/' + data.blockId, refresh);
    }

    getGauageChartData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/migaugedata/' + data.districtId + '/' + data.blockId, refresh);
    }

    getMiTreatmentChartData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/report/mimediacaltreatment/' + data.districtId + '/' + data.blockId, refresh);
    }

    getmedicalIntervention(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/child/mi/' + data.beneficiaryId, refresh);
    }

    getmiEvaluation(data: any, refresh: boolean) {
        return this.dataService.getData('/api/child/mi/evaluationdetail/' + data.beneficiaryId, refresh);
    }

    getmedicalInterventionList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/child/awc/' + data.awcId, refresh);
    }

    getAliveStatus(refresh: boolean) {
        return this.dataService.getData('/api/lookup/alivestatustype', refresh);
    }

    getDeathStatus(refresh: boolean) {
        return this.dataService.getData('/api/lookup/deceasedcausetype', refresh);
    }

    getbeneficiarystatushistory(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/beneficiarystatushistory/' + data.beneficiaryId, refresh);
    }

    getLastEntrydateofchild(data: any, refresh: boolean) {
        return this.dataService.getData('/api/beneficiarystatushistory/lastinspection/' + data.beneficiaryId, refresh);
    }

    beneficiaryStatusSave(result: any) {
        return this.dataService.post('/api/beneficiarystatushistory', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

     getDashboardData(municipalityType:any,regionId: any, districtId: any, blockId: any, municipalityId: any, date: any, foodTiming: any, departmentId: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/eventstatusforweb/'+municipalityType+'/' + regionId + '/' + districtId + '/' + blockId + '/' + municipalityId + '/' + date + '/' + foodTiming + '/' + departmentId, refresh);
     }
    getDistrictWiseBeneficiaryData(eventType: any, areatType: any,municipalityType:any, regionId: any, districtId: any, blockId: any, municipalityId: any, date: any, foodTiming: any, departmentId: any, refresh: boolean) {
        //debugger;
        return this.dataService.getData('/api/dashboard/districtwiselist/' + eventType + '/' + areatType + '/' + municipalityType +'/' + regionId + '/' + districtId + '/' + blockId + '/' + municipalityId + '/' + date + '/' + foodTiming + '/' + departmentId, refresh);
    }

    getHolidays(districtId: number, refresh: boolean) {
        return this.dataService.getData('/api/holiday/' + districtId, refresh)
    }

    // getSchoolsData(districtId: any, blockId: any, municipalityId: any, villagepanchayatId: any, zoneId: any, cookingCenterId: any, eventType, areaType: any, langType: any, date: any, refresh: boolean) {
    //     return this.dataService.getData('/api/school/schoollistbyprogress/' + districtId + '/' + blockId + '/' + municipalityId + '/' + villagepanchayatId + '/' + zoneId + '/' + cookingCenterId + '/' + eventType + '/' + areaType + '/' + langType + '/' + date, refresh);
    // }
    postHoliday(result: any) {
        return this.dataService.post('/api/holiday', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getSchoolsData(result: any) {
        return this.dataService.post('/api/school/schoollistbyprogress', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getHeatmapData(selectedDate: Date, foodTiming: any, refresh: boolean, departmentId: any) {
        return this.dataService.getData('/api/dashboard/heatmap/' + selectedDate + '/' + foodTiming + '/' + departmentId, refresh)
    }

    getSchoolEventTimeline(schoolId: any, langType: any, date: any, foodTiming: any, refresh: boolean) {
        return this.dataService.getData('/api/school/timelineschoolevent/' + schoolId + '/' + langType + '/' + date + '/' + foodTiming, refresh)
    }
    getCookingCenterEventTimeLine(cookingCenterId: any, langType: any, date: any, foodTiming, refresh: boolean) {
        return this.dataService.getData('/api/cookingcenter/timelinecookingcenterevent/' + cookingCenterId + '/' + langType + '/' + date + "/" + foodTiming, refresh);
        // return this.dataService.getData('/api/cookingcenter/timelinecookingcenterevent/'+ cookingCenterId +'/'+{langType}/{date})
    }

    getRouteTable(districtId: number, municipalityId: number, langType: number, refresh: boolean) {
        return this.dataService.getData('/api/route/ccroutes/' + districtId + '/' + municipalityId + '/' + langType, refresh)
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/user/driver/' + id, refresh);
    }

    getTimelineOfVehicle(userId: number, routeId: number, refresh: boolean) {
        return this.dataService.getData('/api/event/drivertripevent/' + userId + '/' + routeId, refresh);
    }

    getCommitteDashboard(districtId, blockId, municipalityId, date) {
        return this.dataService.getData('/api/committeedashboard/eventstatusforweb/' + districtId + '/' + blockId + '/' + municipalityId + '/' + date, true)
    }

    getDrillDownFlow(eventType, areaType, districtId, blockId, municipalityId, date, foodTiming) {
        return this.dataService.getData('/api/committeedashboard/districtwiselist/' + eventType + '/' + areaType + '/' + districtId + '/' + blockId + '/' + municipalityId + '/' + date
            + '/' + foodTiming, true)
    }

    getCommitteHostelList(result) {
        return this.dataService.post('/api/committeedashboard/schoollistbyprogress', result)
    }

    getTimeLinedata(data) {
        return this.dataService.post('/api/committeedashboard/timeline', data)
    }

    getLookupCookingCenters(districtId, refresh) {
        return this.dataService.getData(`/api/lookup/cookingcenter/${districtId}`, refresh)
    }

    getLookupRoutes(ccId, refresh) {
        return this.dataService.getData(`/api/lookup/ccroute/${ccId}`, refresh)

    }

    getCommiteeDataByDate(districtId, startDate, endDate, year, month) {
        return this.dataService.getData('/api/committeedashboard/weekandmonthdashboard/' + districtId + '/' + startDate + '/' + endDate + '/' + year + '/' + month, true);
    }

    getLookupTimePeriodType(langType: any, refresh: any) {
        return this.dataService.getData('/api/lookup/TimePeriodType', refresh)
    }

    getLookupFinancialYearType(langType: any, refresh: any) {
        return this.dataService.getData('/api/lookup/financialYear', refresh)
    }

    getInspectionData(regionId: any,municipalityId: any, municipalityType:any,timePeriodType: any, financialYearId: any, fromDate: any, toDate: any, refresh: boolean) {

        return this.dataService.getData('/api/inspection/inspection-dashboard/' + regionId + '/' + municipalityId + '/' + municipalityType + '/' + timePeriodType + '/' + financialYearId + '/' + fromDate + '/' + toDate, refresh);
    }

     getInspectionDrillDownData( regionId: any,  municipalityId: any, muncipalityType: any, timePeriodType: any, financialYearId: any, fromDate: any,toDate: any, refresh: boolean) {
        //debugger;
        return this.dataService.getData('/api/inspection/inspectionDashboardDrilldown/' + regionId + '/' + municipalityId + '/'+ muncipalityType  + '/' + timePeriodType + '/' + financialYearId + '/' + fromDate  + '/' + toDate, refresh);
    }


    getDrillDownQuestionData( schoolId: any, timePeriodType: any, financialYearId: any, fromDate: any,toDate: any, refresh: boolean) {
        //debugger;
        return this.dataService.getData('/api/inspection/bySchool/' + schoolId + '/' + timePeriodType + '/' + financialYearId + '/' + fromDate  + '/' + toDate, refresh);
    }


}
